import Image from "next/image";
import { useRef } from "react";
import Range from "@/components/ui/slider/Slider";
import { RANGE_OPTION, RANGE_OPTION_SCALE } from "@/const/moveValue";
import downIcon from "@public/down.svg";
import leftRotateIcon from "@public/leftRotate.svg";
import expandIcon from "@public/expand.svg";
import narrowIcon from "@public/narrow.svg";
import upIcon from "@public/up.svg";
import rightRotateIcon from "@public/rightRotate.svg";
import usePartMove from "./PartMove.hook";
import styles from "./PartMove.module.scss";
import scaleUpIcon from "@public/scaleUp.svg";
import scaleDownIcon from "@public/scaleDown.svg";

export default function PartMove() {
	const {
		isShowVertical,
		isShowBreadth,
		isShowRotate,
		isShowScale,
		onVerticalChange,
		onBreadthValueChage,
		onRotateValueChage,
		onScaleValueChage,
		verticalValue,
		breadthValue,
		rotateValue,
		scaleValue,
	} = usePartMove();

	const incrementVerticalRef = useRef<(() => void) | null>(null);
	const decrementVerticalRef = useRef<(() => void) | null>(null);
	const incrementBreadthRef = useRef<(() => void) | null>(null);
	const decrementBreadthRef = useRef<(() => void) | null>(null);
	const incrementRotatehRef = useRef<(() => void) | null>(null);
	const decrementRotatehRef = useRef<(() => void) | null>(null);
	const incrementScalehRef = useRef<(() => void) | null>(null);
	const decrementScalehRef = useRef<(() => void) | null>(null);

	return (
		<div className={styles.partMoveContainer}>
			<div className={styles.rangeContainer}>
				{/* up/down */}
				{isShowVertical && (
					<>
						<Image
							src={downIcon}
							alt="パーツを下に移動する"
							className={styles.icon}
							onClick={() => {
								if (decrementVerticalRef.current) {
									decrementVerticalRef.current();
								}
							}}
						/>
						<Range
							id={1}
							min={RANGE_OPTION.min}
							max={RANGE_OPTION.max}
							step={RANGE_OPTION.step}
							defaultValue={[verticalValue]}
							onValueChange={onVerticalChange}
							onIncrementValue={(incrementFn) => {
								incrementVerticalRef.current = incrementFn;
							}}
							onDecrementValue={(decrementFn) => {
								decrementVerticalRef.current = decrementFn;
							}}
						/>
						<Image
							src={upIcon}
							alt="パーツを上に移動する"
							className={styles.icon}
							onClick={() => {
								if (incrementVerticalRef.current) {
									incrementVerticalRef.current();
								}
							}}
						/>
					</>
				)}
			</div>

			<div className={styles.rangeContainer}>
				{isShowBreadth && (
					<>
						<Image
							src={narrowIcon}
							alt="パーツを内側に狭める"
							className={styles.icon}
							onClick={() => {
								if (decrementBreadthRef.current) {
									decrementBreadthRef.current();
								}
							}}
						/>

						<Range
							id={2}
							min={RANGE_OPTION.min}
							max={RANGE_OPTION.max}
							step={RANGE_OPTION.step}
							defaultValue={[breadthValue]}
							onValueChange={onBreadthValueChage}
							onIncrementValue={(incrementFn) => {
								incrementBreadthRef.current = incrementFn;
							}}
							onDecrementValue={(decrementFn) => {
								decrementBreadthRef.current = decrementFn;
							}}
						/>
						<Image
							src={expandIcon}
							alt="パーツを左右に広げる"
							className={styles.icon}
							onClick={() => {
								if (incrementBreadthRef.current) {
									incrementBreadthRef.current();
								}
							}}
						/>
					</>
				)}
			</div>

			<div className={styles.rangeContainer}>
				{isShowRotate && (
					<>
						<Image
							src={leftRotateIcon}
							alt="パーツの角度を下げる"
							className={styles.icon}
							onClick={() => {
								if (decrementRotatehRef.current) {
									decrementRotatehRef.current();
								}
							}}
						/>
						<Range
							id={3}
							min={RANGE_OPTION.min}
							max={RANGE_OPTION.max}
							step={RANGE_OPTION.step}
							defaultValue={[rotateValue]}
							onValueChange={onRotateValueChage}
							onIncrementValue={(incrementFn) => {
								incrementRotatehRef.current = incrementFn;
							}}
							onDecrementValue={(decrementFn) => {
								decrementRotatehRef.current = decrementFn;
							}}
						/>
						<Image
							src={rightRotateIcon}
							alt="パーツの角度を上げる"
							className={styles.icon}
							onClick={() => {
								if (incrementRotatehRef.current) {
									incrementRotatehRef.current();
								}
							}}
						/>
					</>
				)}
			</div>
			<div className={styles.rangeContainer}>
				{isShowScale && (
					<>
						<Image
							src={scaleDownIcon}
							alt="パーツを縮小する"
							className={styles.icon}
							onClick={() => {
								if (decrementScalehRef.current) {
									decrementScalehRef.current();
								}
							}}
						/>
						<Range
							id={4}
							min={RANGE_OPTION_SCALE.min}
							max={RANGE_OPTION_SCALE.max}
							step={RANGE_OPTION_SCALE.step}
							defaultValue={[scaleValue]}
							onValueChange={onScaleValueChage}
							onIncrementValue={(incrementFn) => {
								incrementScalehRef.current = incrementFn;
							}}
							onDecrementValue={(decrementFn) => {
								decrementScalehRef.current = decrementFn;
							}}
						/>
						<Image
							src={scaleUpIcon}
							alt="パーツを拡大する"
							className={styles.icon}
							onClick={() => {
								if (incrementScalehRef.current) {
									incrementScalehRef.current();
								}
							}}
						/>
					</>
				)}
			</div>
		</div>
	);
}
